import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

export const getUserSpins = ({ accessToken }) =>
  client({
    url: '/gamification/chance',
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
